/**
 * The 14 UK statutory allergens (UK plan Phase 4) — display labels for the
 * backend's Allergen enum names. The list is fixed in law; do not extend it
 * without a matching backend change.
 */
/**
 * Sentinel key for the positive "no known allergens" declaration
 * (Deliveroo-style). UI-only — it is NOT part of the backend Allergen enum;
 * the forms map it to the `allergenFree` boolean on the item payload.
 * Mutually exclusive with every real allergen selection.
 */
export const ALLERGEN_FREE_KEY = 'ALLERGEN_FREE';
export const ALLERGEN_FREE_LABEL = 'No known allergens';

export const ALLERGEN_LABELS: Record<string, string> = {
  CELERY: 'Celery',
  GLUTEN: 'Gluten',
  CRUSTACEANS: 'Crustaceans',
  EGGS: 'Eggs',
  FISH: 'Fish',
  LUPIN: 'Lupin',
  MILK: 'Milk',
  MOLLUSCS: 'Molluscs',
  MUSTARD: 'Mustard',
  PEANUTS: 'Peanuts',
  SESAME: 'Sesame',
  SOYBEANS: 'Soya',
  SULPHITES: 'Sulphites',
  TREE_NUTS: 'Tree nuts',
};
